import { API_URL } from "utils/constants";

export function buildAssetId(asset) {
	return `${asset.id}--${asset.assetType}`;
}

export function buildAssetUrl(libraryId, assetFileName) {
	return `${API_URL}/crm/v1/asset-manager/${libraryId}/images/instantAssets/${assetFileName}`;
}

export function isAfterEffectsAsset(assetType) {
	return /after[-]?effect[s]?/i.test(assetType);
}

export function isImposiumProject(assetType) {
	return /imposiumproject/i.test(assetType);
}

export function isVideoAsset(assetType) {
	return /^video$/i.test(assetType);
}

export const canTranscode = (asset) => {
	if (!asset) {
		return false;
	}
	let { assetType, encoded } = asset;
	let isVideo = isVideoAsset(assetType);
	return (isVideo && !encoded);
};

export function isTextAsset(assetType) {
	return /^text$/i.test(assetType);
}
